import {
  So5LeaderboardType,
  Sport,
} from '@sorare/core/src/__generated__/globalTypes';
import { CommunityBlock } from '@sorare/core/src/components/landing/CommunityBlock';
import { AnySportPastWinner } from '@sorare/core/src/components/landing/CommunityBlock/AnySportPastWinner';

export const Community = () => {
  return (
    <CommunityBlock>
      <AnySportPastWinner
        sport={Sport.BASEBALL}
        leaderboardType={So5LeaderboardType.MLB_COMMON_ALL_STAR}
      />
      <AnySportPastWinner
        sport={Sport.BASEBALL}
        leaderboardType={So5LeaderboardType.MLB_LIMITED_MAJORS}
      />
      <AnySportPastWinner
        sport={Sport.BASEBALL}
        leaderboardType={So5LeaderboardType.MLB_RARE_PRO}
      />
    </CommunityBlock>
  );
};
